import { useModalPromise } from '@cp/shared/modal';
import { useCallback } from 'react';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { PRICE_VACANCY_MODAL, VACANCY_SUCCESS_MODAL } from '../../lib';

export const useResponseVacancyModals = () => {
  const response = useModalPromise(PRICE_VACANCY_MODAL);
  const success = useModalPromise(VACANCY_SUCCESS_MODAL);

  return useCallback(
    async (catalogItem: CatalogItemViewModel, dialogId: number) => {
      await response({ catalogItem, dialogId });
      success({});
    },
    [response, success],
  );
};
